// Module-level access token store — lets non-React code (axiosInstance) access
// the current token without reading from localStorage.
let _accessToken = null;

export const setAccessToken = (token) => { _accessToken = token; };
export const getAccessToken = () => _accessToken;
export const clearAccessToken = () => { _accessToken = null; };
